import * as toml from 'smol-toml'

import tagsStr from './tags.toml?raw'
import typesStr from './types.toml?raw'
import codesStr from './codes.toml?raw'
import telemStr from './telem.toml?raw'

export const tags = toml.parse(tagsStr)
export const types = toml.parse(typesStr)
export const codes = toml.parse(codesStr)
export const telem = toml.parse(telemStr)
